<template>
  <div class="activities">
    <div class="title">
      <div></div>
      会员列表
    </div>
    <div class="query">
      <div class="query-box">
        <el-input v-model="query" placeholder="用户名称/手机号"></el-input>
      </div>
      <div class="query-box">
        <el-select v-model="types" placeholder="请选择会员状态">
          <el-option label="全部" value="全部">全部</el-option>
          <el-option label="生效中" value="生效中">生效中</el-option>
          <el-option label="已过期" value="已过期">已过期</el-option>
        </el-select>
      </div>
      <div class="query-box">
        <el-select v-model="status" placeholder="请选择物流状态">
          <el-option label="全部" value="">全部</el-option>
          <el-option label="未填写" value="0">未填写</el-option>
          <el-option label="未发货" value="1">未发货</el-option>
          <el-option label="已发货" value="2">已发货</el-option>
          <el-option label="已签收" value="3">已签收</el-option>
        </el-select>
      </div>
      <el-button type="primary" @click="inquire">查询</el-button>
      <el-button type="primary" @click="derive">导出</el-button>
    </div>
    <div class="activities-main">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column align="center" prop="headImages" label="头像">
          <template slot-scope="images">
            <el-image
              style="width: 50px; height: 50px"
              class="table-td-thumb"
              :src="images.row.headImages"
              :preview-src-list="[images.row.headImages]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="nickName" label="用户昵称">
        </el-table-column>

        <el-table-column align="center" prop="phone" label="手机号">
        </el-table-column>

        <el-table-column align="center" prop="type" label="购买方式">
          <template slot-scope="scope">
            <div :class="scope.row.type == 2 ? 'active2' : 'active'">
              {{ scope.row.type == 1 ? "购买" : "赠送" }}
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="vipDueTime" label="失效时间">
        </el-table-column>

        <el-table-column align="center" prop="createTime" label="开通时间">
        </el-table-column>

        <el-table-column align="center" prop="amt" label="购买价格">
        </el-table-column>
        <el-table-column align="center" prop="" label="物流状态">
          <template slot-scope="scope">
            <div :class="scope.row.status == 2 ? 'active' : ''">
              {{
                scope.row.status == 2
                  ? "已发货"
                  : scope.row.status == 1
                  ? "未发货"
                  : scope.row.status == 3
                  ? "已签收"
                  : "未填写 "
              }}
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="" label="会员状态">
          <template slot-scope="scope">
            <div :class="scope.row.vipStatus == 1 ? 'active' : ''">
              {{ scope.row.vipStatus == 1 ? "生效中" : "已过期" }}
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="handleAddress(scope.row.id)"
              >收货地址</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 收货地址 -->
    <el-dialog title="收货地址" :visible.sync="addressShow" width="30%" center>
      <div v-if="addressShow2">
        <div class="box">
          <div class="box-left">
            收货人：<span>{{ addressInfo.contacts }}</span>
          </div>
          <div class="box-right">
            联系电话 ：<span>{{ addressInfo.phone }}</span>
          </div>
        </div>
        <div class="box">
          <div class="box-left">
            邮政编码：<span>{{ addressInfo.postalCode }}</span>
          </div>
          <div class="box-right">
            状态 ：<span>{{
              addressInfo.status == 1
                ? "未发货"
                : addressInfo.status == 2
                ? "已发货"
                : "已签收"
            }}</span>
          </div>
        </div>
        <div class="box">
          <div>
            地区：<span>{{ addressInfo.region }}</span>
          </div>
        </div>
        <div class="box">
          <div>
            详细地址：<span>{{ addressInfo.address }}</span>
          </div>
        </div>
        <el-form
          ref="addressInfo"
          :model="addressInfo"
          label-width="80px"
          :rules="rules"
        >
          <!-- <el-form-item label="快递公司" prop="courierServicesCompany">
            <el-input v-model="addressInfo.courierServicesCompany"></el-input>
          </el-form-item> -->
          <el-form-item label="快递公司">
            <el-select
              v-model="addressInfo.courierServicesCompany"
              placeholder="请选择"
            >
              <el-option
                :label="item.name"
                :value="item.name"
                v-for="(item, i) in expressList"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物流订单" prop="courierNumber">
            <el-input v-model="addressInfo.courierNumber"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="!addressShow2" style="width: 100%; text-align: center">
        暂时未添加地址
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addressShow = false">取 消</el-button>
        <el-button
          v-if="!addressShow2"
          type="primary"
          @click="addressShow = false"
          >确 定</el-button
        >
        <el-button
          v-if="addressShow2 && addressInfo.status == 2"
          type="primary"
          @click="shipments('addressInfo')"
          >修改</el-button
        >
        <el-button
          v-if="addressShow2 && addressInfo.status == 1"
          type="primary"
          @click="shipments('addressInfo')"
          >发货</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import local from "@/utils/local.js";
import {
  webVipUserPage,
  IP,
  webGetReceivingAddress,
  deliverGoods,
  expressList,
  functiondownload,
} from "@/api/api";
export default {
  data() {
    return {
      status: "",
      //  activityId: "",
      ruleList: [],
      query: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      adminId: "",
      types: "",
      addressInfo: {},
      addressShow: false,
      addressShow2: false,
      expressList: [],
      rules: {
        courierServicesCompany: [
          { required: true, message: "请输入快递公司", trigger: "blur" },
        ],
        courierNumber: [
          { required: true, message: "请输入物流订单", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.adminId = local.get("id");
    this.getList();
    this.expressLists();
  },
  methods: {
    // 导出
    derive() {
      functiondownload(
        "/web/user/webVipUserPageExportExcel",
        {
          query: this.query,
          type: this.type,
          status: this.status,
        },
        true
      );
    },
    //设置排序序号
    async setSort(id, sort) {
      let res = await updateScenicSpotHot({
        spotId: id,
        hotSort: sort,
      });
      this.getList();
    },

    //  获取用户列表
    async getList() {
      let res = await webVipUserPage({
        query: this.query,
        type: this.type,
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        status: this.status,
      });
      console.log(res);
      let { data } = res;
      //边界判断
      if (!data.itemList.length && this.currentPage !== 1) {
        this.currentPage -= 1;
        this.getList();
      }
      data.itemList.forEach((item) => {
        item.amt = "￥" + item.amt;
      });
      this.tableData = data.itemList;
      console.log(this.tableData, 9898);
      this.total = data.totalSize;
    },
    // 查询
    inquire() {
      // console.log(this.status)
      // return
      if (this.types == "全部") {
        this.type = "";
      } else if (this.types == "生效中") {
        this.type = 1;
      } else if (this.types == "已过期") {
        this.type = 2;
      }
      this.getList();
    },
    // 刷新
    refresh() {
      this.query = "";
      this.getList();
    },
    //每页多少条
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    //当前多少页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    // 收货地址
    async handleAddress(id) {
      let res = await webGetReceivingAddress({ orderId: id });
      if (res.code == 200) {
        this.addressShow = true;
        if (res.data) {
          this.addressInfo = res.data;
          this.addressShow2 = true;
        } else {
          this.addressInfo = {};
          this.addressShow2 = false;
        }
      }
    },
    // 发货
    shipments(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await deliverGoods({
            courierNumber: this.addressInfo.courierNumber,
            courierServicesCompany: this.addressInfo.courierServicesCompany,
            id: this.addressInfo.id,
          });
          if (res.code == 200) {
            this.addressShow = false;
            this.$message({
              message: "发货成功",
              type: "success",
            });
            this.getList();
          }
        } else {
          return false;
        }
      });
    },
    // 快递公司列表
    async expressLists() {
      let res = await expressList();
      this.expressList = res.data;
    },
  },
};
</script>

<style lang="less" scoped>
.activities {
  // height: 100%;
  background: #fff;
  padding: 15px;
  color: #303133;
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;

    div {
      width: 3px;
      height: 16px;
      background: #409eff;
      margin-right: 10px;
    }
  }
  .query {
    margin: 15px 0 30px;
    display: flex;
    align-items: center;
    .query-box {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .el-input {
        width: 260px;
      }
      span {
        width: 60px;
      }
    }
  }
  .activities-main {
    margin: 15px 0;
  }
  .paging {
    display: flex;
    justify-content: flex-end;
  }
}
.active {
  color: #33b959;
}
.active2 {
  color: #d15f65;
}
.box {
  padding: 0 50px;
  width: 80%;
  display: flex;
  margin-bottom: 35px;
  // justify-content: space-between;
  .box-left {
    width: 300px;
  }
  .box-right {
    width: 240px;
  }
}
</style>